module.exports = __webpack_public_path__ + "img/stats-bar-light-01.a6318571.jpg";